import ArticleEditor from './article-editor';
import './article_editor_plugins/blockcode/blockcode';
import './article_editor_plugins/buttonlink/buttonlink';
import './article_editor_plugins/counter/counter';
import './article_editor_plugins/definedlinks/definedlinks';
import './article_editor_plugins/handle/handle';
import './article_editor_plugins/icons/icons';
import './article_editor_plugins/imageposition/imageposition';
import './article_editor_plugins/inlineformat/inlineformat';
import './article_editor_plugins/makebutton/makebutton';
import './article_editor_plugins/print/print';
import './article_editor_plugins/reorder/reorder';
import './article_editor_plugins/selector/selector';
import './article_editor_plugins/specialchars/specialchars';
import './article_editor_plugins/style/style';
import './article_editor_plugins/tags/tags';
import './article_editor_plugins/textdirection/textdirection';
import './article_editor_plugins/underline/underline';
import './article_editor_plugins/variable/variable';

function importAll(r) {
  let images = {};
  r.keys().map((item, index) => {
    images[item.replace('./', '')] = r(item);
  });
  return images;
}
function initializeArticle(elementClass) {
  return ArticleEditor(elementClass, {
    image: {
      upload: '/admin/content_files',
      select: '/admin/content_files',
      drop: false,
      multiple: false,
      name: "content_file[data]",
      data: {
        authenticity_token: window.POC.csrfToken()
      }
    },
    editor: {
      classname: 'rx-editor-content'
    },
    addbar: ['paragraph', 'image', 'embed', 'line', 'table', 'snippet', 'quote', 'code', 'grid', 'layer', 'text'],
    styles: {
      paragraph: {
        'Hero Header': {
          title: '<span class="hero-header">Hero Header</span>',
          classname: 'hero-header'
        },

        'Hero Header Italic': {
          title: '<span class="hero-header-italic">Hero Header Italic</span>',
          classname: 'hero-header-italic'
        },

        'Hero message': {
          title: '<span class="hero-message">Hero message</span>',
          classname: 'hero-message'
        },

        'Large Header': {
          title: '<span class="large-header">Large Header</span>',
          classname: 'large-header'
        },

        'Large Header Italic': {
          title: '<span class="large-header-italic">Large Header Italic</span>',
          classname: 'large-header-italic'
        },

        'Med Header': {
          title: '<span class="med-header">Med Header</span>',
          classname: 'med-header'
        },

        'Med Header Italic': {
          title: '<span class="med-header-italic">Med Header Italic</span>',
          classname: 'med-header-italic'
        },

        'Small Header': {
          title: '<span class="small-header">Small Header</span>',
          classname: 'small-header'
        },

        'Small Header Italic': {
          title: '<span class="small-header-italic">Small Header Italic</span>',
          classname: 'small-header-italic'
        },

        'Paragraph': {
          title: '<span class="paragraph">Paragraph</span>',
          classname: 'paragraph'
        }
      }
    },
    custom: {
      css: [
        window.POC.ARTICLE_EDITOR_CSS_URL
      ]
    },
    plugins: [
      'blockcode',
      'buttonlink',
      'counter',
      'definedlinks',
      'handle',
      'icons',
      'imageposition',
      'inlineformat',
      'makebutton',
      'print',
      'reorder',
      'selector',
      'specialchars',
      'style',
      'tags',
      'textdirection',
      'underline',
      'variable'
    ],
    grid: {
      classname: 'row',
      columns: 12,
      gutter: '1px',
      offset: {
        left: '15px',
        right: '15px'
      },
      patterns: {
        '6|6': 'col-6|col-6',
        '4|4|4': 'col-4|col-4|col-4',
        '3|3|3|3': 'col-3|col-3|col-3|col-3',
        '2|2|2|2|2|2': 'col-2|col-2|col-2|col-2|col-2|col-2',
        '3|6|3': 'col-3|col-6|col-3',
        '2|8|2': 'col-2|col-8|col-2',
        '5|7': 'col-5|col-7',
        '7|5': 'col-7|col-5',
        '4|8': 'col-4|col-8',
        '8|4': 'col-8|col-4',
        '3|9': 'col-3|col-9',
        '9|3': 'col-9|col-3',
        '2|10': 'col-2|col-10',
        '10|2': 'col-10|col-2',
        '12': 'col-12'
      }
    }
  })
}
$(function() {
  initializeArticle(".redactor-content")
})

export default initializeArticle;